import { API_URL } from './constants'

export class ApiError extends Error {
    constructor(message, status) {
        super(message)
        this.name = 'ApiError'
        this.status = status
    }
}

export async function apiRequest(path, options = {}) {
    const response = await fetch(`${API_URL}${path}`, {
        credentials: 'include',
        ...options,
        headers: {
            accept: 'application/json',
            ...(options.headers || {}),
        },
    })

    if (response.status === 401 || response.status === 403) {
        throw new ApiError('Unauthorized', response.status)
    }

    if (!response.ok) {
        throw new ApiError(`Request failed: ${response.status}`, response.status)
    }

    if (response.status === 204) {
        return null
    }

    return response.json()
}
